/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useLocation} from 'react-router-dom'
import {useMemo} from 'react'

export const usePDPSearchParams = (productId) => {
    const {search} = useLocation()

    const allParams = useMemo(() => new URLSearchParams(search), [search])

    // small optimization to avoid parsing the product search params in case they did not change, but something else in the search changed
    const productSearch = allParams.get(productId) || ''

    const productParams = useMemo(() => new URLSearchParams(productSearch), [productSearch])

    return [allParams, productParams]
}
